var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { fontWeights, colors as syfColors, fontSizes as syfFontSizes, spacing as syfSpacing } from 'syf-component-library/defaultTheme';
var colors = __assign(__assign({}, syfColors), { trueBlack: '#000000', lightTurquoise: '#f1f8f8', paleGrey: '#fafafa' });
var spacing = __assign(__assign({}, syfSpacing), { xxxlarge: 48 });
var fontSizes = __assign(__assign({}, syfFontSizes), { regular: '14' });
var textAlign = {
    center: 'center',
    left: 'left',
    right: 'right'
};
export { colors, fontSizes, fontWeights, spacing, textAlign };
//# sourceMappingURL=theme.js.map